import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { CATALOG as DEFAULT_CATALOG } from '../constants/catalog';

const API_URL = process.env.REACT_APP_API_BASE_URL || '';

export function useCatalog() {
  const { authorizedFetch } = useAuth();
  const [catalog, setCatalog] = useState(DEFAULT_CATALOG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authorizedFetch(`${API_URL}/api/catalog`)
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(data => { if (data && typeof data === 'object') setCatalog(data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [authorizedFetch]);

  return { catalog, loading };
}
